<template>
    <canvas
        id="lwf-container"
        ref="lwfContainer"
        class="aspect-[3/4] w-full"
        height="0"
        width="0"
    ></canvas>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import "@/lib/lwf.js";

const props = defineProps({
    lwf: {
        type: String,
        required: true,
    },
});

const lwfContainer = ref(null);
const url = new URL(props.lwf);
const segments = url.pathname.split("/").filter(Boolean);
const lastSegment = segments.pop();
let cache;
let animation;
let currentTime;
let fromTime;

onMounted(async () => {
    LWF.useCanvasRenderer();
    cache = LWF.ResourceCache.get();

    cache.loadLWF({
        lwf: lastSegment,
        prefix: `${url.origin}/${segments.join("/")}/`,
        stage: lwfContainer.value,
        fitForHeight: 568,
        fitForWidth: 426,
        onload: function (lwf) {
            lwf.rootMovie.attachMovie("ef_001", "ef_001");
            lwf.rootMovie.moveTo(
                lwfContainer.value.width / 2,
                lwfContainer.value.height / 2,
            );
            animation = lwf;
        },
    });

    play();
});

function play() {
    window.requestAnimationFrame(play);

    if (animation != null) {
        animation.exec(tick());
        animation.render();
    }
}

function tick() {
    currentTime = Date.now() / 1000.0;
    const tick = currentTime - fromTime;
    fromTime = currentTime;
    return tick;
}

onUnmounted(() => {
    if (animation) {
        cache.unloadLWF(animation);
        animation = null;
    }
});
</script>

<style scoped></style>
